// import {lazy} from 'react';
// const Discover = lazy(() => import(/* webpackChunkName: "Discover" */ '../containers/Discover/Discover'));
// const Article = lazy(() => import(/* webpackChunkName: "Article" */ '../containers/Discover/Article'));
// const PlayerPage = lazy(() => import(/* webpackChunkName: "PlayerPage" */ '../containers/Discover/PlayerPage'));
// const LearnDiscoverTutorialPage = lazy(
// 	() => import(/* webpackChunkName: "LearnDiscoverTutorialPage" */ '../containers/Learn/LearnDiscoverTutorialPage'),
// );

import Discover from '../containers/Discover/Discover';
import Article from '../containers/Discover/Article';
import PlayerPage from '../containers/Discover/PlayerPage';
import LearnDiscoverTutorialPage from '../containers/Learn/LearnDiscoverTutorialPage';

import {
	DISCOVER_TAB,
	DISCOVER_TAB_LEARN_TUTORIAL,
	DISCOVER_TAB_ARTICLE,
	DISCOVER_TAB_VIDEO,
} from '../components/LeftNav/constants';

export const DiscoverRoutes = [
	{
		component: Discover,
		path: '/cc/discover',
		tab: DISCOVER_TAB,
		titleId: 'app.document.title.home',
		exact: true,
	},
	{
		component: Discover,
		path: '/cc/discover/learn/app/:appName',
		tab: DISCOVER_TAB,
		titleId: 'app.document.title.home',
		exact: true,
	},
	{
		component: LearnDiscoverTutorialPage,
		path: '/cc/discover/learn/:app/:level/:field/:playlist/:tutorial',
		tab: DISCOVER_TAB,
		subTab: DISCOVER_TAB_LEARN_TUTORIAL,
		titleId: 'app.document.title.learn',
	},
	{
		component: LearnDiscoverTutorialPage,
		path: '/cc/discover/learn/:app/:level/:field/:playlist/',
		tab: DISCOVER_TAB,
		subTab: DISCOVER_TAB_LEARN_TUTORIAL,
		titleId: 'app.document.title.learn',
	},
	{
		component: Article,
		path: '/cc/discover/article/:articleSlug',
		tab: DISCOVER_TAB,
		subTab: DISCOVER_TAB_ARTICLE,
		titleId: 'app.document.title.home',
	},
	{
		component: PlayerPage,
		path: '/cc/discover/video/:videoSlug/:videoId',
		tab: DISCOVER_TAB,
		subTab: DISCOVER_TAB_VIDEO,
		titleId: 'app.document.title.home',
	},
	{
		component: Discover,
		path: '/cc/discover/:category',
		tab: DISCOVER_TAB,
		titleId: 'app.document.title.home',
		exact: true,
	},
];
